<template>
	<div>
		<v-tabs v-if="environmentId" v-model="tab" vertical>
			<v-tab key="General">{{ $t("general") }}</v-tab>
			<v-tab key="Job Stage Items Prod" v-if="!value.subStage">{{
				$t("entities.jobStage.tabs.form.jobStageItemsProd")
			}}</v-tab>
			<v-tab key="Job Stage Items Cons" v-if="!value.subStage">{{
				$t("entities.jobStage.tabs.form.jobStageItemsCons")
			}}</v-tab>

			<v-tabs-items v-model="tab">
				<v-tab-item key="General" eager>
					<v-container>
						<v-form ref="form" v-model="valid">
							<v-checkbox
								:readonly="value.id != null"
								v-model="value.subStage"
								:label="$t('entities.stage.props.subStage')"
							></v-checkbox>
							<v-select
								v-model="value.status"
								:label="$t('entities.jobStage.props.status')"
								:items="environment.jobStageStatus"
								item-value="status"
								item-text="status"
								:rules="$isRequiredRule"
							></v-select>
							<v-text-field
								v-model="value.description"
								:label="$t('entities.jobStage.props.description')"
								clearable
								:rules="$isRequiredRule"
							></v-text-field>
							<v-text-field
								v-model="value.seq"
								label="Seq"
								clearable
								:rules="$isRequiredRule"
							></v-text-field>
							<auto-complete-entity
								:readonly="value.id != null"
								v-if="value.subStage"
								:loading="loadingItem"
								ref="item"
								v-model="value.itemId"
								entityApi="item"
								:itemPreSelected="selectedItem"
								itemText="description"
								itemValue="id"
								:label="$t('entities.stage.props.itemId')"
								:rules="value.subStage ? $isRequiredRule : []"
								prependIcon="mdi-find-replace"
							/>
							<v-select
								:readonly="value.id != null"
								v-if="value.subStage"
								:items="versions"
								v-model="value.versionId"
								item-text="description"
								item-value="id"
								:label="$t('entities.stage.props.versionId')"
								:rules="value.subStage ? $isRequiredRule : []"
								:loading="loadingVersion"
							/>
							<v-autocomplete
								v-if="!value.subStage"
								v-model="value.resourceId"
								:items="resources"
								:label="$t('entities.jobStage.props.resourceId')"
								item-text="description"
								item-value="id"
								:rules="$isRequiredRule"
								:clearable="!value.id"
							></v-autocomplete>
						</v-form>
					</v-container>
				</v-tab-item>

				<v-tab-item key="Job Stage Items Prod" eager>
					<jobStageItemProdTab v-model="value" />
				</v-tab-item>
				<v-tab-item key="Job Stage Items Cons" eager>
					<jobStageItemConsTab v-model="value" />
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
	import jobStageItemConsTab from "./jobStageItemConsTab";
	import jobStageItemProdTab from "./jobStageItemProdTab";
	import itemService from "@/services/itemService";
	import resourceService from "@/services/resourceService"
	import versionService from "@/services/versionService";
	export default {
		components: {
			jobStageItemConsTab,
			jobStageItemProdTab,
		},
		props: {
			value: {},
			environmentId: {},
		},
		data() {
			return {
				entityService: resourceService,
				tab: null,
				valid: true,
				resources: [],
				stageTypes: [],
				environment: {
					jobStageStatus: [],
					jobStatus: [],
				},
				selectedItem: null,
				versions: [],
				loadingVersion: false,
				loadingItem: false,
			};
		},
		watch: {
			async "value.itemId"() {
				await this.getVersions();
			},
			async environmentId() {
				await this.getEnvironment();
			},
			async value() {
				await this.getItems();
			},
		},
		methods: {
			isValid() {
				return this.$refs.form.validate();
			},
			async getItem() {
				if (!this.value.itemId) return;
				this.loadingItem = true;
				let res = await itemService.getById(this.value.itemId);
				this.loadingItem = false;
				if (res.success) this.selectedItem = res.data;
			},
			async getVersions() {
				if (!this.value.itemId) return;
				this.loadingVersion = true;
				let res = await versionService.getAll(this.value.itemId);
				this.loadingVersion = false;
				if (res.success) this.versions = res.data.data;
			},
			async getItems() {
				await this.getItem();
				await this.getVersions();
				if (!this.value.subStage) {
					await this.getResources();
					await this.getStageTypes();
				}
				await this.getEnvironment();
			},
			async getEnvironment() {
				let res = await this.$http.get(
					`environment/s-id?id=${
						this.value.environmentId == null
							? this.environmentId
							: this.value.environmentId
					}`
				);
				if (res.success) {
					let environment = res.data;
					if (environment) this.environment = environment;
				}
			},
			async getResources() {
				let res = await this.entityService.getAll(1, 1000000) //this.$http.get("resource");
				if (res.success) this.resources = res.data.data;
			},
			async getStageTypes() {
				let res = await this.$http.get("stageType");
				if (res.success) this.stageTypes = res.data.data;
			},
		},
		async mounted() {
			if (!this.value.jobStageItemConss) this.value.jobStageItemConss = [];
			if (!this.value.jobStageItemProds) this.value.jobStageItemProds = [];
			await this.getItems();
		},
	};
</script>
